import Dexie from 'dexie';
const db = new Dexie("userData")
db.version(1).stores({
  user: '++id,&userId,userName,name,lastName,surName,email,phone,token,roleName',
  initializedData: '++id,transactionID,code,description,tokenType,data',
  echo: '++id,Action,timestamp,geolocalization,status,meta',
  lego: '++id,transactionID,code,description' })

export const persistence = {}//Objeto contenedor de funciones de base de datos indexed DB

persistence.InitializeData = () => {//Almacenar datos de la inicialización echo
  return db.initializedData.put({
    transactionID: '',
    code: '',
    description: '',
    tokenType: '',
    data:''
  })
}

persistence.SaveEcho = () => {//Almacenar echo
  return db.echo.put({
    Action: '',
    timestamp: '',
    geolocalization: '',
    status: '',
    meta: ''
  })
}

persistence.SaveLego = () => {//Almacenar Lego
  return db.lego.put({
    transactionID: '',
    code: '',
    description: ''
  })
}

persistence.SaveUser = (res) => {//Almacenar datos de usuario
  return db.user.put({
    userId: res.userId,
    userName: res.userName,
    name: res.name,
    lastName: res.lastName,
    surName: res.surName,
    email: res.email,
    phone: res.phone,
    token: res.token,
    roleName: res.roleName
  })
  //db.close() //cerrar conexión a base local
}

persistence.GetSession = () => {//Obtener los datos de usuario de la sesión
  return db.user.toArray()
}

persistence.GetUserRegistered = (user) => {//Saber sí un usuario ya ha sido registrado
  return db.user.where('userName').equalsIgnoreCase(user).toArray()
}

persistence.GetInitializeData = () => {
  return db.initializedData.toArray()
}

persistence.GetEchoData = () => {
  return db.echo.toArray()
}

persistence.GetLegoData = () => {
  return db.lego.toArray()
}

persistence.EndSession = () => {
  //Finializar sesión del usuario
  //cookies.remove('token') /*Eliminar token de cookies*/
  return db.user.clear()
}
